import React from 'react'
import Report from './report'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { BannerStatic } from '../../../components'

const ContentReport = ({ tenantId, templateName }) => {
  const [urlReportGenerate] = useEvent([
    {
      eventName: 'urlReportGenerate',
      onSuccess: ({ url }) => {
        window.open(url, '_blank')
      },
      onError: () => {
        BannerStatic.show({
          label: 'There was an error when downloading the report.',
          isError: true
        })
      }
    }
  ])

  const handleContentReportDownload = () => {
    // Although the templateName isn't used in the backend to generate the report, it is being sent to be stored on the event tracker
    urlReportGenerate.trigger({
      tenantId,
      templateName
    })
  }

  return (
    <Report
      name='Content Report'
      description='CSV with all contents available to this client for LXP/CMS import.'
      buttonText='Download CSV'
      onClick={handleContentReportDownload}
      isWorking={urlReportGenerate.isWorking}
    />
  )
}

export default ContentReport
